<!-- Zweck: Stellt die HTML-Struktur für shop warenkorb menu component im Frontend bereit. -->
<div class="wkmenu">
  @if (!add_mode) {
    <div>
      <div class="title">Warenkorb auswählen</div>
      @for (wk of wksvc.warenkoerbe$|async; track wk) {
        <div (click)="addToWarenkorb(wk, data.entry);"
          class="menuitem">
          @if ((wksvc.primary_warenkorb$|async) && (wksvc.primary_warenkorb$|async)?.id == wk.id) {
            <svg-icon
              style="font-size: 12px; height: 12px">radiobutton-gefuellt
            </svg-icon>
          }
          @if ((wksvc.primary_warenkorb$|async) && (wksvc.primary_warenkorb$|async)?.id != wk.id) {
            <svg-icon
              style="font-size: 12px; height: 12px">radiobutton-leer
            </svg-icon>
          }
          @if (wk.readonly_impersonation_workspace) {
            <mat-icon style="vertical-align: middle" matTooltip="Temporärer Warenkorb der Read-only-Impersonation" aria-label="Temporärer Warenkorb der Read-only-Impersonation">schedule</mat-icon>
          }
          {{wk.label}}
        </div>
      }
      <div class="spacer"></div>
      <div (click)="add()" class="menuitem">
        <svg-icon>warenkorb-hinzufuegen</svg-icon>
        Neuer Warenkorb
      </div>
      @if (!(usvc.user$|async)?.readonly_impersonated && data.entry && data.entry.artikel && !data.entry.artikel.IstDtpArtikel) {
        <div class="spacer"></div>
        <button mat-button (click)="fastOrder(data.entry);" style="width: 100%; border-radius: 0; background-color: lightgreen">
          <svg-icon>bezahlen</svg-icon> Sofort bestellen
        </button>
      }
    </div>
  }
  @if (add_mode) {
    <div>
      <div class="title">Neuer Warenkorb</div>
      <div class="paddedcontent">
        <mat-form-field appearance="outline">
          <input [(ngModel)]="newwk.label" matInput
            placeholder="Bezeichnung">
        </mat-form-field>
        <br>
          @if (!(usvc.user$|async)?.readonly_impersonated) {
            <mat-checkbox [(ngModel)]="newwk.shared">Geteilt</mat-checkbox>
          }
          <hr>
            <button (click)="save()" mat-button>
              <svg-icon>speichern</svg-icon>
              {{ saveLabel }}
            </button>
            <button (click)="cancel()" mat-button>
              <svg-icon>abbrechen</svg-icon>
              Abbrechen
            </button>
          </div>
        </div>
      }
    </div>
